export const TOAST_IDS = {
    basicToastId: 'basic-toast',
    linkToastId: 'link-toast',
};
